/**
 * LexIDE feature-flag helpers — legacy surface retired in L.7.
 *
 * Historically this module exposed `getLayoutMode` + `getAiEditorMode`
 * + `getExperienceMode` to dispatch between v1 (chat-left/editor-right
 * + TipTap Petition Studio) and v2 (four-pane layout + AIEditor). The
 * v2 rollout flipped the default on 2026-04-20 (commit `fba25262`);
 * L.7 (2026-04-22) deleted the v1 mounts entirely, so there's nothing
 * left to gate.
 *
 * The exported constants below remain only to clean up localStorage on
 * first load after the L.7 deploy, so users don't carry a stale
 * `LEXIDE_EXPERIENCE=v1` preference from a pre-L.7 session. That
 * cleanup runs once per session via `purgeLegacyFlags()`, called from
 * `App.tsx`.
 */

const LS_EXPERIENCE = "LEXIDE_EXPERIENCE";
const LS_LAYOUT = "LEXIDE_LAYOUT";
const LS_AIEDITOR = "AIEDITOR_MODE";

/**
 * Remove the retired LEXIDE_EXPERIENCE / LEXIDE_LAYOUT / AIEDITOR_MODE
 * localStorage keys. Idempotent; safe to call on every mount. Kept
 * as a one-off transition helper — can be deleted 30 days after L.7
 * deploy when user localStorage has had time to be cleared naturally.
 */
export function purgeLegacyFlags(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(LS_EXPERIENCE);
    window.localStorage.removeItem(LS_LAYOUT);
    window.localStorage.removeItem(LS_AIEDITOR);
  } catch {
    // Non-fatal — safari private mode can throw; the consequence is
    // the user sees the transition flicker once more.
  }
}
